if (!customElements.get("m-bundle-block")) {
  class MBundleBlock extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector("[data-add-bundle]");
      this.errorWrapper = this.querySelector(".m-bundle-block__error");
      this.selects = this.querySelectorAll("[data-companion-select]");
      this.hiddenIds = this.querySelectorAll("[data-companion-id]");
      this.discountPercent = Number(this.dataset.discountPercent) || 15;

      this.button.addEventListener("click", this._addBundle.bind(this));
      this.selects.forEach((select) => select.addEventListener("change", this._updatePrices.bind(this)));

      // Suivre le changement de variante du produit courant (prix potentiellement différent)
      if (window.MinimogEvents && window.MinimogTheme && window.MinimogTheme.pubSubEvents) {
        window.MinimogEvents.on(window.MinimogTheme.pubSubEvents.variantChange, ({ data }) => {
          const productInfo = this.closest("product-info");
          if (!productInfo || !data || data.sectionId !== productInfo.dataset.sectionId) return;
          const variant = data.variant;
          if (!variant || !variant.id) return;
          this.dataset.currentVariant = variant.id;
          this.dataset.currentPrice = variant.price;
          const priceEl = this.querySelector(".m-bundle-block__item [data-item-price]");
          const { formatMoney } = window;
          if (priceEl && typeof formatMoney === "function") {
            const moneyFormat = window.MinimogSettings && window.MinimogSettings.money_format;
            priceEl.dataset.price = variant.price;
            priceEl.querySelector("del").innerHTML = formatMoney(Number(variant.price), moneyFormat);
            priceEl.querySelector("strong").innerHTML = formatMoney(
              Math.round((Number(variant.price) * (100 - this.discountPercent)) / 100),
              moneyFormat
            );
          }
          this._updatePrices();
        });
      }
    }

    _currentVariantId() {
      const productInfo = this.closest("product-info");
      const mainInput = productInfo && productInfo.querySelector(".m-product-form--main form [name=id]");
      return (mainInput && mainInput.value) || this.dataset.currentVariant;
    }

    _companionItems() {
      const items = [];
      this.selects.forEach((select) => {
        const option = select.options[select.selectedIndex];
        items.push({ id: Number(option.value), price: Number(option.dataset.price) });
      });
      this.hiddenIds.forEach((input) => {
        items.push({ id: Number(input.value), price: Number(input.dataset.price) });
      });
      return items;
    }

    _updatePrices(e) {
      const { formatMoney } = window;
      if (typeof formatMoney !== "function") return;
      const moneyFormat = window.MinimogSettings && window.MinimogSettings.money_format;
      const discountItem = (price) => Math.round((price * (100 - this.discountPercent)) / 100);

      if (e && e.target) {
        const option = e.target.options[e.target.selectedIndex];
        const priceEl = e.target.closest(".m-bundle-block__item").querySelector("[data-item-price]");
        if (priceEl && option) {
          priceEl.dataset.price = option.dataset.price;
          priceEl.querySelector("del").innerHTML = formatMoney(Number(option.dataset.price), moneyFormat);
          priceEl.querySelector("strong").innerHTML = formatMoney(discountItem(Number(option.dataset.price)), moneyFormat);
        }
      }

      const prices = [Number(this.dataset.currentPrice), ...this._companionItems().map((item) => item.price)];
      const total = prices.reduce((sum, p) => sum + p, 0);
      const discounted = prices.reduce((sum, p) => sum + discountItem(p), 0);
      this.querySelector("[data-bundle-regular]").innerHTML = formatMoney(total, moneyFormat);
      this.querySelector("[data-bundle-discounted]").innerHTML = formatMoney(discounted, moneyFormat);
      const savingsEl = this.querySelector("[data-bundle-savings]");
      if (savingsEl) savingsEl.innerHTML = formatMoney(total - discounted, moneyFormat);
    }

    _addBundle(e) {
      e.preventDefault();
      const { MinimogSettings, MinimogStrings, MinimogTheme } = window;
      const cartDrawer = document.querySelector("m-cart-drawer");

      const sectionsToBundle = [];
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:grouped-sections", { bubbles: true, detail: { sections: sectionsToBundle } })
      );

      const items = [
        { id: Number(this._currentVariantId()), quantity: 1 },
        ...this._companionItems().map((item) => ({ id: item.id, quantity: 1 })),
      ];

      const config = fetchConfig("javascript");
      config.method = "POST";
      config.body = JSON.stringify({ items, sections: sectionsToBundle, sections_url: window.location.pathname });

      if (this.button.disabled) return;
      this.button.classList.add("m-spinner-loading");
      this.button.disabled = true;
      fetch(`${MinimogSettings.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this._showError(response.description || MinimogStrings.cartError);
            return;
          }
          if (MinimogSettings.use_ajax_atc && cartDrawer && MinimogSettings.enable_cart_drawer) {
            MinimogTheme.Notification.show({
              target: cartDrawer.querySelector("m-cart-items"),
              method: "prepend",
              type: "success",
              message: MinimogStrings.itemAdded,
              delay: 400,
            });
            cartDrawer.open();
            window.MinimogEvents.emit(MinimogTheme.pubSubEvents.cartUpdate, { cart: response });
            document.dispatchEvent(new CustomEvent("product-ajax:added", { detail: { product: response } }));
          } else {
            window.location = MinimogSettings.routes.cart;
          }
        })
        .catch(() => {
          this._showError("Error");
        })
        .finally(() => {
          this.button.classList.remove("m-spinner-loading");
          this.button.disabled = false;
        });
    }

    _showError(message) {
      window.MinimogTheme.Notification.show({
        target: this.errorWrapper,
        method: "appendChild",
        type: "warning",
        message,
      });
    }
  }
  customElements.define("m-bundle-block", MBundleBlock);
}
